import SessionContext from 'contexts/session';
import { useContext } from 'react';

const useUser = () => {
  const { user } = useContext(SessionContext);
  return user;
};

export default useUser;
